import { MutableRefObject } from "react";
import { ExerciseInterface, ObjectiveInterface } from "../../interfaces/examInterfaces";
import MeasureExercise from "./MeasureExercise";
import { Box } from "@mui/system";
import ExamFooter from "./Layouts/Legacy/LegacyExamFooter";
import ExamHeader from "./Layouts/Legacy/LegacyExamHeader";
import {
  ExamSheetContainer,
  TopSpacer,
  ExercisesContainer,
  TotalPointsContainer,
  TotalPoints,
} from "./Layouts/Legacy/LegacyStyles";

export const MeasureContainer = ({
  pageIndex,
  selectedObjective,
  pageExercises,
  exerciseRefs,
  pages,
  examName,
  isMeasuringContainer,
  containerRef,
  examHeaderRef,
  totalPointsRef,
  imageUrls,
}: {
  pageIndex: number;
  selectedObjective: ObjectiveInterface | null;
  pageExercises: ExerciseInterface[];
  exerciseRefs: MutableRefObject<(HTMLDivElement | null)[]>;
  pages: ExerciseInterface[][];
  examName: string;
  isMeasuringContainer: boolean;
  containerRef: MutableRefObject<HTMLDivElement | null>;
  examHeaderRef: MutableRefObject<HTMLDivElement | null>;
  totalPointsRef: MutableRefObject<HTMLDivElement | null>;
  imageUrls: { [key: string]: string };
}) => {
  const zoomFactor = 1;

  return (
    <ExamSheetContainer key={pageIndex} zoomfactor={zoomFactor} sx={{ visibility: "hidden" }}>
      <TopSpacer zoomfactor={zoomFactor} />
      {pageIndex === 0 && selectedObjective && (
        <Box ref={examHeaderRef}>
          <ExamHeader
            title={selectedObjective.topic}
            objectiveIndex={selectedObjective.objectiveIndex}
            objective={selectedObjective.objective}
            zoomFactor={zoomFactor}
          />
        </Box>
      )}

      {isMeasuringContainer ? (
        <ExercisesContainer ref={containerRef}></ExercisesContainer>
      ) : (
        <ExercisesContainer>
          {pageExercises.map((exercise: ExerciseInterface, index: number) => {
            const imageUrl = imageUrls[exercise.id];
            return (
              <div ref={(el) => (exerciseRefs.current[index] = el)} key={index}>
                <MeasureExercise exercise={exercise} imageUrl={imageUrl} zoomFactor={zoomFactor} />
              </div>
            );
          })}
        </ExercisesContainer>
      )}

      {pageIndex === pages.length - 1 && (
        <TotalPointsContainer ref={totalPointsRef} zoomfactor={zoomFactor}>
          <TotalPoints zoomfactor={zoomFactor}>/10</TotalPoints>
        </TotalPointsContainer>
      )}

      {selectedObjective && (
        <ExamFooter
          examName={examName}
          zoomFactor={zoomFactor}
          title={selectedObjective.topic}
          objectiveIndex={selectedObjective.objectiveIndex}
        />
      )}
    </ExamSheetContainer>
  );
};
